/**
 * Created by mark on 6/27/2019.
 */
import Service from "../../AuthService";

const SaleReturnProduct = {
    getSaleReturnProduct(page) {
        return Service.get("/sale-return-product?page="+page);
    },
    showSaleReturnProduct(id) {
        return Service.get("/sale-return-product/" + id);
    },
    updateSaleReturnProduct(id, data) {
        return Service.put("/sale-return-product/" + id, data);
    },
    createSaleReturnProduct(data) {
        return Service.post("/sale-return-product", data);
    },
    deleteSaleReturnProduct(id) {
        return Service.delete("/sale-return-product/" + id);
    },
    searchSaleReturnProduct(page,data){
        return Service.post(`/sale-return-product-search?page=${page}`,data);
    },
    getCustomerFromSaleID(sale_id){
        return Service.get('/sale_return_product_customer/'+sale_id);
    },
    getInvoiceFromCustomerID(customer_id){
        return Service.get('/sale_return_product_invoices/'+customer_id);
    },
    getInvoiceDetails(invoice_id,cause_id){
        return Service.get('/sale_return_product_invoice_details?invoice_id='+invoice_id+'&cause_id='+cause_id);
    },
    getInvoiceBack(customer_id){
        return Service.get('/sale_return_product_invoices_back?customer_id='+customer_id);
    },
    getTransportFromCustomer(customer_id){
        return Service.get("/transport_from_customer_return/"+customer_id);
    },

    /*update 14/4/2563*/
    getReturnMinPrice(data){
        return Service.get('get_return_price_form_invoice?product_id='+data.product_id+'&customer_id='+data.customer_id
        );
    },
    calculateDetails(data){
        return Service.post('/calculate_details',data);
    },
    generateCN(date){
        return Service.get('/generate_cn_number?date='+date);
    },
    //create Credit_note
    createCreditnote(data){
        return Service.post('/credit_note',data);
    },
    deleteCreditnote(id){
        return Service.delete('/credit_note/'+id);
    },
    //get credit note
    getCreditNote(page,data){
        return Service.get(`/credit_note?page=${page}&customer_id=${data.customer_id}&product_id=${data.product_id}&invoice_id=${data.invoice_id}`);
    },
    printCreditNotePDF(id){
        return Service.get(`/merge/credit_note_merge_pdf?id=${id}`)
    }
};

export default SaleReturnProduct;

